import React, { useState } from "react";
import { FaPlus, FaCheck, FaTimes, FaTrash } from "react-icons/fa";

const SelectField = React.forwardRef(
  (
    {
      label,
      options = [],
      error,
      allowAdd = false,
      allowDelete = false,
      onAddOption,
      onDeleteOption,
      placeholder = "-- Pilih --",
      name,
      value,
      onChange,
      ...props
    },
    ref
  ) => {
    const [isAdding, setIsAdding] = useState(false);
    const [newOption, setNewOption] = useState("");

    const handleAdd = () => {
      const trimmed = newOption.trim();
      if (!trimmed || options.some((o) => o.label === trimmed)) return;
      onAddOption?.(trimmed);
      setNewOption("");
      setIsAdding(false);
    };

    const handleDelete = () => {
      if (!value) return;
      const confirmDelete = window.confirm(`Hapus opsi ini?`);
      if (!confirmDelete) return;
      onDeleteOption?.(value);
      onChange?.({ target: { name, value: "" } });
    };

    return (
      <div className="mb-5">
        {label && (
          <label
            htmlFor={name}
            className="block mb-1 text-sm font-semibold text-green-800"
          >
            {label}
          </label>
        )}

        {!isAdding ? (
          <div className="flex items-center gap-2">
            <select
              id={name}
              name={name}
              ref={ref}
              value={value}
              onChange={(e) =>
                onChange?.({ target: { name, value: e.target.value } })
              }
              className={`w-full px-3 py-2 text-sm transition border rounded-md focus:ring-2 
                ${
                  error
                    ? "border-red-500 focus:ring-red-300"
                    : "border-green-300 focus:ring-green-400"
                }`}
            >
              <option value="">{placeholder}</option>
              {options.map((opt, i) => (
                <option key={i} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>

            {allowAdd && (
              <button
                type="button"
                onClick={() => setIsAdding(true)}
                className="p-2 text-white transition bg-green-600 rounded hover:bg-green-700"
                title="Tambah Opsi"
              >
                <FaPlus size={14} />
              </button>
            )}

            {allowDelete && value && (
              <button
                type="button"
                onClick={handleDelete}
                className="p-2 text-white transition bg-red-500 rounded hover:bg-red-600"
                title="Hapus Opsi"
              >
                <FaTrash size={14} />
              </button>
            )}
          </div>
        ) : (
          <div className="flex items-center gap-2 mt-1">
            <input
              type="text"
              value={newOption}
              onChange={(e) => setNewOption(e.target.value)}
              placeholder="Input opsi baru"
              className="w-full px-3 py-2 text-sm transition border border-green-300 rounded-md focus:ring-2 focus:ring-green-400"
              autoFocus
            />
            <button
              type="button"
              onClick={handleAdd}
              className="p-2 text-white bg-green-600 rounded hover:bg-green-700"
              title="Simpan"
            >
              <FaCheck size={14} />
            </button>
            <button
              type="button"
              onClick={() => {
                setNewOption("");
                setIsAdding(false);
              }}
              className="p-2 text-white bg-gray-400 rounded hover:bg-gray-500"
              title="Batal"
            >
              <FaTimes size={14} />
            </button>
          </div>
        )}

        {error && <p className="mt-1 text-xs text-red-500">{error.message}</p>}
      </div>
    );
  }
);

export default SelectField;
